import * as React from "react";
const SvgExpandCustom = (props) => /* @__PURE__ */ React.createElement("svg", { id: "uuid-2f81a9ff-679b-4035-b859-4a71879e4e9f", "data-name": "uuid-f2619d4d-5adf-466c-9e22-b2c89a1ba0ef", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 16", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m20,0v16h-1.5V0h1.5Z", style: {
  fill: "currentColor",
  strokeWidth: 0
} }), /* @__PURE__ */ React.createElement("path", { d: "m1.5,16H0V0h1.5v16Z", style: {
  fill: "currentColor",
  strokeWidth: 0
} }), /* @__PURE__ */ React.createElement("path", { d: "m12.5,5l1-1,4,4-4,4-1-1,2.25-2.25H5.25l2.25,2.25-1,1-4-4,4-4,1,1-2.25,2.25h9.5l-2.25-2.25Z", style: {
  fill: "currentColor",
  strokeWidth: 0
} }));
export default SvgExpandCustom;
